import { useEffect } from 'react';
import initApp from 'utils/functions/init';
import { categories, contexts } from 'constants/context';
import ServicesView from 'modules/services/views/ServicesView';
import { fetchSpecialities } from 'modules/services/actions';
import { useDispatch } from 'react-redux';
import { fetchCategories } from 'modules/masterServices/actions';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const ServicesPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();

  const initialServicesListApiCallBody = {
    pageNum: 1,
    pageSize: 10,
    categoryKey: categories.labs,
    includeTotalCount: true,
    isDeleted: false,
    includes: ['MasterService', 'ServiceSpecialities', 'ServicePreparations'],
  };
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    initApp(contexts.services, categories.labs);
    dispatch(fetchSpecialities());
    dispatch(fetchCategories());
  }, [dispatch]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <ServicesView initialServicesListApiCallBody={initialServicesListApiCallBody} />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

ServicesPage.propTypes = {};

ServicesPage.defaultProps = {};

export default ServicesPage;
